var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-item"},[_vm._t("default"),_c('p',{staticClass:"exam-item__title"},[_vm._v(_vm._s(_vm.exam.text))]),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }